import React, { useRef, useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { fetchDotw, DotwModalProps, DotwTrigger } from '@/components/Dotw';
import { SFErrorBoundary } from '@/components/ErrorBoundary';

const DotwModal = dynamic(import('@/components/Dotw'), {
  ssr: false,
});

const DotwError = dynamic<Partial<DotwModalProps>>(
  import('@/components/Dotw').then(mod => mod.DotwErrorFallbackComponent),
  {
    ssr: false,
  }
);

const NavDotw = (): JSX.Element => {
  const dotwData = useRef(null);
  const [dotwFetchState, setDotwFetchState] = useState('idle');
  const [openDotwModal, setOpenDotwModal] = useState(false);

  useEffect(() => {
    (async () => {
      setDotwFetchState('fetching');

      const res = await fetchDotw();
      dotwData.current = res;

      setDotwFetchState('finished');
    })();
  }, [dotwData]);

  const isDotwLoading =
    dotwFetchState == 'fetching' || dotwFetchState == 'idle';
  const displayDotw =
    dotwData?.current?.display === true && dotwFetchState !== 'error';

  return (
    <>
      <DotwTrigger
        isLoading={isDotwLoading}
        setOpenDotwModal={setOpenDotwModal}
        display={displayDotw}
        dotwData={dotwData?.current}
      />
      {displayDotw && (
        <SFErrorBoundary
          targetComponent={'DOTW'}
          fallbackComponent={
            <DotwError
              setOpenDotwModal={setOpenDotwModal}
              open={openDotwModal}
            />
          }>
          {open ? (
            <DotwModal
              setOpenDotwModal={setOpenDotwModal}
              open={openDotwModal}
              display={displayDotw}
              data={dotwData.current}
            />
          ) : null}
        </SFErrorBoundary>
      )}
    </>
  );
};

export default NavDotw;
